import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import * as api from "../../services/api";

export default function AdminDashboard() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    if (!authLoading && (!user || user.role !== "admin")) navigate("/");
  }, [user, authLoading, navigate]);

  useEffect(() => {
    api.getAdminStats()
      .then((d) => setStats(d.stats || null))
      .catch(() => {});
  }, []);

  if (authLoading) return <div className="p-12">Loading...</div>;
  if (!user || user.role !== "admin") return null;

  const statCards = [
    { label: "Total Users", value: stats?.total_users ?? "—" },
    { label: "Total Runs", value: stats?.total_runs ?? "—" },
    { label: "Runs Today", value: stats?.runs_today ?? "—" },
    { label: "Active Subscriptions", value: stats?.active_subscriptions ?? "—" },
  ];

  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-10 py-12">
      <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
        {statCards.map((s) => (
          <div key={s.label} className="border rounded-xl p-6 text-center">
            <p className="text-3xl font-bold text-indigo-600">{s.value}</p>
            <p className="text-sm text-gray-600 mt-1">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <Link to="/admin/users" className="border rounded-xl p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold mb-2">Manage Users</h3>
          <p className="text-sm text-gray-600">View, search, and edit user accounts and plans.</p>
        </Link>
        <Link to="/admin/tools" className="border rounded-xl p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold mb-2">Manage Tools</h3>
          <p className="text-sm text-gray-600">Toggle tool availability and premium status.</p>
        </Link>
        <Link to="/admin/runs" className="border rounded-xl p-6 hover:shadow-md transition">
          <h3 className="text-lg font-semibold mb-2">Inspect Runs</h3>
          <p className="text-sm text-gray-600">Monitor execution status, latency, and user activity.</p>
        </Link>
        <Link to="/admin/settings" className="border rounded-xl p-6 hover:shadow-md transition border-indigo-100 bg-indigo-50/40">
          <h3 className="text-lg font-semibold mb-2">Site Settings</h3>
          <p className="text-sm text-gray-600">Edit content, contact info, color theme, and site operations.</p>
        </Link>
      </div>
    </div>
  );
}